export default "__VITE_ASSET__DfZUTSX7__"